"use client";

import { CtaButton } from "@/base/component/cta-button";
import UneedBadge from "@/base/component/uneed";
import { Button } from "@heroui/react";
import { IconArrowRight } from "@tabler/icons-react";
import { useRouter } from "next/navigation";
import Script from "next/script";

export default function Hero() {
  const router = useRouter();

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "SEO AI Pal",
    "applicationCategory": "SEO Tool",
    "offers": {
      "@type": "Offer",
      "price": "9.99",
      "priceCurrency": "EUR",
    },
    "description":
      "AI-powered platform for website SEO optimization, analysis and content monitoring. Get actionable insights to improve your website's search visibility.",
  };

  return (
    <>
      <Script id="product-schema" type="application/ld+json">
        {JSON.stringify(schemaData)}
      </Script>
      <section className="container mx-auto flex flex-1 flex-col items-center justify-center overflow-hidden px-8">
        <article className="flex flex-col items-center justify-center gap-[18px] sm:gap-6 max-w-4xl">
          <UneedBadge />
          <Button
            className="h-9 z-20 overflow-hidden border-1 border-default-100 bg-default-50 px-[18px] py-2 text-small font-medium leading-5 text-default-800 plausible-event-name=hero-faq"
            endContent={
              <IconArrowRight
                className="flex-none outline-none [&>path]:stroke-[2]"
                width={20}
                aria-hidden="true"
              />
            }
            radius="full"
            variant="bordered"
            onPress={() => router.push("#faq")}
            aria-label="Navigate to Frequently Asked Questions section"
          >
            Frequently asked questions
          </Button>

          <div className="flex flex-col">
            <h1 className="text-center text-[clamp(40px,10vw,44px)] font-bold leading-[1.2] tracking-tighter sm:text-[60px] bg-hero-section-title bg-clip-text text-default-900">
              SEO Made Simple for Indie Hackers
            </h1>
          </div>

          <p className="text-center font-normal leading-7 text-default-700 sm:text-[18px]">
            Get AI-driven SEO insights, actionable recommendations, and
            real-time content monitoring to improve your website's search
            visibility, drive organic traffic, and stay ahead of industry
            trends.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mt-2">
            <CtaButton
              className="plausible-event-name=hero-analyze-now"
              radius="full"
              size="lg"
              onPress={() => router.push("/#pricing")}
            >
              Analyze Now
            </CtaButton>

            <Button
              className="h-11 z-20 overflow-hidden border-1 border-default-100 bg-default-50 px-[18px] py-2 text-small font-medium leading-5 text-default-800 plausible-event-name=hero-vs-competitors"
              endContent={
                <IconArrowRight
                  className="flex-none outline-none [&>path]:stroke-[2]"
                  width={20}
                  aria-hidden="true"
                />
              }
              radius="full"
              variant="bordered"
              onPress={() => router.push("/seo-ai-pal-vs-competitors")}
              aria-label="Compare SEO AI Pal with competitors"
            >
              SEO AI Pal vs Competitors
            </Button>
          </div>
        </article>
      </section>
    </>
  );
}
